import { render } from "./WarehouseItems.vue?vue&type=template&id=5e837fd0&scoped=true"
import script from "./WarehouseItems.vue?vue&type=script&lang=js"
export * from "./WarehouseItems.vue?vue&type=script&lang=js"

import "./WarehouseItems.vue?vue&type=style&index=0&id=5e837fd0&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e837fd0"]])

export default __exports__